import { useEffect, useRef, useState } from 'react';

interface IntersectOptions {
  root?: Element | null;
  rootMargin?: string;
  threshold?: number | number[];
}

type UseIntersectReturn = [
  (node: Element | null) => void,
  IntersectionObserverEntry | NonNullable<unknown>
];

const useIntersect = ({
  root = null,
  rootMargin,
  threshold = 0
}: IntersectOptions = {}): UseIntersectReturn => {
  const [entries, updateEntry] = useState<
    IntersectionObserverEntry | NonNullable<unknown>
  >({});
  const [node, setNode] = useState<Element | null>(null);

  const observer = useRef(
    new IntersectionObserver(([entry]) => updateEntry(entry), {
      root,
      rootMargin,
      threshold
    })
  );

  useEffect(() => {
    const { current: currentObserver } = observer;
    currentObserver.disconnect();

    if (node) {
      currentObserver.observe(node);
    }

    return () => currentObserver.disconnect();
  }, [node]);

  return [setNode, entries];
};

export default useIntersect;
